<script>
import date from 'locutus/php/datetime/date'
import { createGroupMember, fetchGroupList } from '@apis/admin/member'

export default {
  props: {
    group_seq: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      params: {
        member_seq: Number(this.$route.params.member_seq) || 0,
        group_seq: 0,
      },
      data: null,
      loading: false,
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.loading = true
      Promise.all([this.loadGroupList()])
        .catch((e) => this.$toasted.error(e.message))
        .finally(() => {
          this.loading = false
        })
    },
    async loadGroupList() {
      const { data } = await fetchGroupList()

      this.data = data
    },
    handleSubmit() {
      const confirm_message = this.$t('admin.msg_enroll')
      const success_message = this.$t(
        'member_by_group_info.msg_membership_group'
      )

      this.loading = true
      this.$confirm(confirm_message, this.$t('admin.modal_confirm'))
        .then(() => createGroupMember(this.params))
        .then(({ seq }) => this.$emit('submit', seq))
        .then(() => this.$toasted.success(success_message))
        .catch((e) => (e ? this.$toasted.error(e.message) : null))
        .finally(() => {
          this.loading = false
        })
    },
    date,
  },
}
</script>

<template>
  <form
    v-loading="loading"
    action="./"
    method="get"
    @submit.prevent="handleSubmit"
  >
    <table cellspacing="0" cellpadding="0" :class="$style.rowTable">
      <colgroup>
        <col width="20%" />
        <col width="30%" />
        <col width="20%" />
        <col width="30%" />
      </colgroup>
      <tbody>
        <tr>
          <th scope="row"
            ><div>{{ $t('member_by_group_info.select_group') }}</div></th
          >
          <td>
            <select v-model="params.group_seq">
              <option :value="0">{{
                $t('member_by_group_info.msg_select_group')
              }}</option>
              <option v-for="{ seq, title } in data" :key="seq" :value="seq">{{
                title
              }}</option>
            </select>
          </td>
        </tr>
        <tr>
          <th colspan="4" :class="$style.button">
            <span :class="[$style.button, $style.black]"
              ><input type="submit" :value="$t('admin.enroll')"
            /></span>
          </th>
        </tr>
      </tbody>
    </table>
  </form>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';
</style>
